export default __webpack_public_path__ + "static/media/p8.bfc385f2.png";